import { Toast, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from '@/components/DataTable';
import { FeatureTable } from '@/components/Features/FeatureTable';
import React, { useState } from 'react';
import { FeatureToggleWithDefinitionDTO, getProjectFeatures, postFeature } from '@/services/featureToggle';
import { BygrProject, SortDirection } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';

export interface ProjectFeaturesProps {
    project: BygrProject;
    reloadProject(): void;
}

const DataTable = createDataTable<FeatureToggleWithDefinitionDTO>();

export const ProjectFeatures: React.FC<ProjectFeaturesProps> = ({ project }) => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('featureName', SortDirection.Ascending, 20));
    const [projectFeatures, , reload] = useAsyncStateWithIsLoading(
        () => getProjectFeatures({ ...tableState, projectId: project.id }),
        [],
        null
    );
    const [, setIsSaving] = useState(false);
    if (!projectFeatures) return <LoadingIndicator />;

    const handleFeatureToggle = async (checked: boolean, feature: string) => {
        setIsSaving(true);
        try {
            await postFeature({
                featureName: feature,
                projectId: project.id,
                toggled: checked,
            });
            reload();
            Toast.success('Feature toggled');
        } catch (e) {
            Toast.warning('Something went wrong :( ');
            console.log(e);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <FeatureTable
            data={projectFeatures.items}
            handleFeatureToggle={handleFeatureToggle}
            setTableState={setTableState}
            tableState={tableState}
            includeProfileColumn={true}
        />
    );
};
